import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Complaint } from 'src/libs-common/models/complaint.model';

@Injectable({
  providedIn: 'root',
})
export class ComplaintsService {
  headers = {
    'Content-Type': 'application/json'
  };

  constructor(private http: HttpClient) { }

  sendEnquiry(complaintData: Complaint) {
    return this.http.post(environment.apiUrl + '/complaints', complaintData, {
      responseType: 'json',
      observe: 'body',
      headers: this.headers,
    });
  }
}
